import React from 'react'
import styles from './additional-info.module.scss'
import { Typography } from '@/ui-kit'
import { Profile } from '@/types/profile'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

interface Props {
    profile: Profile,
    className?: string
}

export const AdditionalInfo: React.FC<Props> = ({ profile, className }) => {
    const { t, i18n } = useTranslation()

    const additionalInfo = profile.additional_info
    
    const moreInfoItems = {
        catch_my_interest: additionalInfo?.catch_my_interest,
        my_ideal_evening: additionalInfo?.my_ideal_evening,
        height: additionalInfo?.height,
        marital_status: additionalInfo?.marital_status,
        smoking: additionalInfo?.smoking,
        drinking: additionalInfo?.drinking,
        children: additionalInfo?.children,
        language_proficiency: additionalInfo?.language_proficiency,
    }

    const renderFieldVal = (field: string, val?: string | Array<string> | number | null) => {
        if (Array.isArray(val))
            return val.join(', ')
        if (i18n.exists(`${field}.${val}`))
            return t(`${field}.${val}`, { context: profile.gender })
        return val
    }

    return (
        Object.values(moreInfoItems).some(e => {
            if (typeof e === 'number') return e
            if (typeof e === 'string') return e.length
            return false
        }) && (
            <div className={clsx(styles.wrapper, className)}>
                <Typography
                    variant="label"
                    fontWeight="normal"
                    fontFamily="SFProText">
                    {t('additional_info')}
                </Typography>
                <ul className={styles.items}>
                    {
                        Object
                            .entries(moreInfoItems)
                            .filter(([field, val]) => {
                                if (typeof val === 'string') {
                                    if (val === 'not_specified') return false
                                    return val.length
                                }
                                if (Array.isArray(val)) return val.length
                                if (val === null) return false
                                return true
                            })
                            .map(([field, val]) => 
                                <li>
                                    <div>
                                        <Typography
                                            variant="label"
                                            fontWeight="normal"
                                            fontFamily="SFProText"
                                            className={styles.subtitle}>
                                            {t(`${field}.title`)}
                                        </Typography>
                                    </div>

                                    <Typography className={styles.value} variant="p">
                                        {renderFieldVal(field, val)}
                                    </Typography>
                                </li>
                            )
                    }
                </ul>
            </div>
        )
    )
}
